module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/11mill-inactive-8a33cc43163d88f53a25b3fe42b78a88.png";